import {EntityData, EntityModel} from "@fedeltapointofsale/data-client";
import {SpecialData} from "./special.data";
import {Injectable, Injector} from "@angular/core";
import {PriceLevelSearchModel} from "../price-level/price-level-search.model";
import {TranslateService} from "@ngx-translate/core";
import {MembershipTypeReferenceData} from "../../customers/membership-type/membership-type.data";
import {MembershipTypeSearchModel} from "../../customers/membership-type/membership-type-search.model";

@Injectable()
export class SpecialEntityModel extends EntityModel<SpecialData> {

    constructor(injector: Injector) {
        super(injector, SpecialData);
    }

    protected override onAfterLoadEntity(special: SpecialData): void {
        const translateService: TranslateService = this.injector.get(TranslateService, null)
        if (special.useRealTime && !special.priceLevelId) {
            special.priceLevelId = PriceLevelSearchModel.ACTIVE_PRICE_LEVEL;
            special.priceLevel.priceLevelId = PriceLevelSearchModel.ACTIVE_PRICE_LEVEL;
            special.priceLevel.name = translateService.instant("wbo.special.edit.option.priceLevel.activePriceLevel");
        }
        if (special.memberLoyalty.includeGuests) {
            const guest: MembershipTypeReferenceData = EntityData.create(MembershipTypeReferenceData);
            guest.name = translateService.instant("wbo.membership-type.option.guest");
            guest.membershipTypeId = MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE;
            special.memberLoyalty.specialMemberTypes.unshift(guest);
        }
    }

    protected override onBeforeSaveEntity(special: SpecialData): void {
        special.useRealTime = !!special.priceLevelId || special.priceLevelId === PriceLevelSearchModel.ACTIVE_PRICE_LEVEL;
        if (special.priceLevelId === PriceLevelSearchModel.ACTIVE_PRICE_LEVEL) {
            special.priceLevelId = null;
        }
        special.memberLoyalty.includeGuests = !!special.memberLoyalty.specialMemberTypes.find((member: MembershipTypeReferenceData) => member.membershipTypeId === MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
        special.memberLoyalty.specialMemberTypes = special.memberLoyalty.specialMemberTypes.filter((member: MembershipTypeReferenceData) => member.membershipTypeId !== MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE);
    }
}
